export default "__VITE_ASSET__ab9e496c__"